export * from './IconFunnel';
